import Info from './forms/Info'
import Scope from './forms/Scope'
import SiteViparis from './forms/SiteViparis'
import Site from './forms/Site'
import Manif from './forms/Manif'

type AdminUserScreen = (props: AdminUserFormProps) => JSX.Element | null

const SCREENS: { [key in AdminUserStep]: AdminUserScreen } = {
  info: Info,
  scope: Scope,
  site: Site,
  site_viparis: SiteViparis,
  manif: Manif,
}

export { SCREENS }
